//import React from 'react'
import firebase from 'firebase';

export class GetManyService {
  getMany = (resource, params) => {
    console.log('getMany', resource);
    return firebase
      .database()
      .ref(resource)
      .once('value')
      .then(snapshot => {
        const response = Object.entries(snapshot.val()).map(entry =>
          Object.assign({}, { id: entry[0] }, entry[1])
        );
        return { data: response };
      });
  };
}



// WEBPACK FOOTER //
// ./src/services/GetManyService.js